import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { BankAccountsClient } from "../../../../../../Wrap/Api/BankAccounts/BankAccounts";
import { DrawdownIncomeAmendmentInstructionClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownIncomeAmendmentInstruction";
import { DrawdownIncomeAmendmentInstructionCalculationsClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownIncomeAmendmentInstructionCalculations";
import { BankAccount } from "../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { DrawdownIncomeAmendmentModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeAmendmentModel";
import { GadReviewInstructionDispatcher } from "../Store/Variable";

export class GadReviewAction {
    public static createInstruction(model: DrawdownIncomeAmendmentModel, clientId: number): void {
        const client = new DrawdownIncomeAmendmentInstructionClient();
        const promise = client.post(model);
        promise.onSuccess((result) => {
            this.getInstruction(
                result.DrawdownIncomeAmendmentInstruction.Id,
                model?.DrawdownIncomeAmendmentInstruction?.HierarchyId,
                clientId
            );
        });
        promise.onError((err) => {});
    }

    public static getInstruction(instructionId: number, subAccountHierarchyid: string, clientId: number): void {
        const client = new DrawdownIncomeAmendmentInstructionClient();
        const promise = client.get(instructionId, subAccountHierarchyid, clientId);
        promise.onSuccess((result) => {
            result.DrawdownIncomeAmendmentInstruction.ExistingArrangements = {
                CappedModels: [
                    {
                        Id: 1111,
                        From: "1111",
                        Amount: 100000,
                        Type: "Member",
                        GadMaximum: 15000,
                        Taxable: true,
                        IncomeTakenToDate: 1300,
                        NextYearsGadMaximum: 20000,
                        LastMandatoryReview: JsonDateParser.toJsonDateNoOffset(new Date(2020, 1, 1)),
                        MaximumIncomePaymentForRemainderOfPensionYear: 1000,
                        MaximumIncomePaymentForFuturePensionYears: 2000,
                    },
                    {
                        Id: 2222,
                        From: "2222",
                        Amount: 100000,
                        Type: "Member",
                        GadMaximum: 15000,
                        Taxable: true,
                        IncomeTakenToDate: 1300,
                        NextYearsGadMaximum: 20000,
                        LastMandatoryReview: JsonDateParser.toJsonDateNoOffset(new Date(2020, 1, 1)),
                        MaximumIncomePaymentForRemainderOfPensionYear: 1000,
                        MaximumIncomePaymentForFuturePensionYears: 2000,
                    },
                ],
                FlexiModels: [
                    {
                        Id: 1234,
                        From: "1234",
                        Amount: 10000,
                        Type: "Member",
                        MaximumIncomePerPayment: 1000,
                    },
                    {
                        Id: 2234,
                        From: "2234",
                        Amount: 10000,
                        Type: "Inherited",
                        MaximumIncomePerPayment: 2000,
                    },
                ],
            };
            GadReviewInstructionDispatcher.dispatch({ actionType: ActionType.Success, payload: result });
        });
        promise.onError((err) => {});
    }

    private static getDrawdownIncomeCalculations(instructionId: number, callback?: (result) => void) {
        const client = new DrawdownIncomeAmendmentInstructionCalculationsClient();
        const promise = client.get(instructionId);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });
    }

    public static getBankAccounts(hierarchyId: string, callBack: (result: BankAccount[]) => void) {
        const client = new BankAccountsClient();
        const promoise = client.get(hierarchyId);

        promoise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static saveInstruction(data: any, callback?: (result) => void): void {
        const client = new DrawdownIncomeAmendmentInstructionClient();
        const promise = client.post(data);
        promise.onSuccess((result) => {
            GadReviewInstructionDispatcher.dispatch({ actionType: ActionType.Success, payload: result });
            if (callback) {
                callback([]);
            }
        });

        promise.onError((err) => {});
    }

    public static submitInstruction(data, callback?: VoidFunction): void {
        const client = new DrawdownIncomeAmendmentInstructionClient();
        const promise = client.post(data);
        promise.onSuccess((result) => {
            GadReviewInstructionDispatcher.dispatch({ actionType: ActionType.Success, payload: result });
            if (callback) {
                callback();
            }
        });

        promise.onError((err) => {});
        Promise.resolve(callback());
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        Promise.resolve(callback());
    }
}
